import { PropsWithChildren } from 'react';

import { ContentStyled } from './Content.styles';

interface Props extends PropsWithChildren {
  className?: string;
}

export const Content = ({ children, className }: Props) => (
  <ContentStyled className={className}>{children}</ContentStyled>
);
